/**
 * useOrderMethod
 * The custom hook which provided to external use via context
 */

import { useContext } from 'react'

import OrderMethodContext from './order-method-context'

const useOrderMethod = () => {
  const context = useContext(OrderMethodContext)

  return context
}

export default useOrderMethod
